module.exports = __webpack_public_path__ + "img/DISPTCHD_ORANGE.f9eff277.svg";